
import configCard from './config-card.vue';

export default {
  components: {
    configCard: configCard
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formValue: {
        no_dev: '',
        no_dev_test: ''
      }
    };
  },

  computed: {
    formItemList: function formItemList() {
      var list = [{
        visible: !this.readOnly,
        label: '是否需要介入：',
        type: 'radio-group',
        prop: 'no_dev',
        rules: [{
          required: true,
          message: '请选择是否需要研发介入',
          trigger: 'change'
        }],
        params: {
          disabled: false,
          options: [{
            label: '需要',
            value: 2
          }, {
            label: '不需要',
            value: 1
          }],
          button: true
        }
      }, {
        visible: this.readOnly,
        label: '是否需要介入：',
        type: 'plain-text',
        prop: 'no_dev_test'
      }];
      return list;
    }
  },
  watch: {
    'formValue.no_dev': function formValueNo_dev(val) {
      this.schemeValue.no_dev = val;
    },
    'schemeValue.fetch_data': function schemeValueFetch_data(val) {
      if (val) {
        this.fillForm();
      }
    }
  },
  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    fillForm: function fillForm() {
      if (this.schemeValue.no_dev !== '') {
        this.formValue.no_dev = this.schemeValue.no_dev;
        this.formValue.no_dev_test = Number(this.schemeValue.no_dev) === 1 ? '不需要' : '需要';
      }
    }
  },
  mounted: function mounted() {
    this.fillForm();
  }
};